/**
 * Admin write schemas for WebsitePressMention (Phase 5 - CMS write API).
 *
 * `contentHtml` is Tiptap-emitted; we cap at 200KB which is a safety
 * boundary, not a UX expectation (a press writeup is usually <5KB).
 * `publicationDate` is an ISO date (no time) since press dates carry no
 * timezone.
 */

import { z } from 'zod';

import { UuidSchema } from './common.js';

export const CreateWebsitePressMentionRequestSchema = z.object({
  title: z.string().min(1).max(255),
  contentHtml: z.string().min(1).max(200_000),
  thumbnailId: UuidSchema.nullish(),
  publicationDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/u, 'Date must be YYYY-MM-DD'),
  redirectTo: z.string().min(1).max(2048),
  sortOrder: z.number().int().min(0).default(0),
});
export type CreateWebsitePressMentionRequest = z.infer<
  typeof CreateWebsitePressMentionRequestSchema
>;

export const UpdateWebsitePressMentionRequestSchema =
  CreateWebsitePressMentionRequestSchema.partial();
export type UpdateWebsitePressMentionRequest = z.infer<
  typeof UpdateWebsitePressMentionRequestSchema
>;
